export default __webpack_public_path__ + "static/public-health-hero-e6106bf6559ac60227dbe80f35b72be2.webp";